const state =  {
    is_load_event_fired : false,
    call_in_mounting : false
}

const getters  = {
    is_load_event_fired : (state) => state.is_load_event_fired,
    call_in_mounting : (state) => state.call_in_mounting
}

const actions = {
    setIsLoadEventFired({commit}, bool) {
        commit('setIsLoadEventFired', bool);
    },
    setCallInMounting({commit}, bool) {
        commit('setCallInMounting', bool)
    }
}

const mutations = {
    setIsLoadEventFired(state, bool) {
        state.is_load_event_fired = bool;
    },
    setCallInMounting(state, bool) {
        state.call_in_mounting = bool;
    }
}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}